import request from 'client/utils/request'

export function fetchPaymentData(pageId) {
  return request.get(`/sales/${pageId}/page/data/product`)
}
